import React from "react";
import "./HowItWorksPage.css";

const HowItWorksPage = () => {
  return (
    <div className="howitworkspage-root">
      <h1 className="howitworkspage-title">How It Works Page</h1>
      <p className="howitworkspage-description">How It Works Page Placeholder</p>
    </div>
  );
};

export default HowItWorksPage;
